export default __webpack_public_path__ + "static/media/benefit9.fa96bf03.png";